// @flow

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import CustomEvent from 'custom-event';
import Swipe from 'react-easy-swipe';
import AudioToggle from 'AudioToggle';
import Html from 'Html';
import WheelActItem from 'WheelActItem';
import WheelStoryItem from 'WheelStoryItem';

class Wheel extends PureComponent {
  static defaultProps = {
    entities: [],
    fieldSubtitle: '',
    fieldShortDescription: '',
    storyline: [],
    location: {
      pathname: '',
      hash: '',
    },
  };

  static propTypes = {
    entities: PropTypes.arrayOf(PropTypes.any.isRequired),
    fieldSubtitle: PropTypes.string,
    fieldShortDescription: PropTypes.string,
    storyline: PropTypes.arrayOf(
      PropTypes.shape({
        entityLabel: PropTypes.string.isRequired,
        fieldSubtitle: PropTypes.string.isRequired,
        fieldThemeColor: PropTypes.string.isRequired,
        entityUrl: PropTypes.shape({
          alias: PropTypes.string.isRequired,
        }),
      }),
    ),
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      hash: PropTypes.string.isRequired,
    }),
  };

  constructor(props) {
    super(props);

    this.isVerticalSwipe = false;
    this.rerunAnimations = false;

    this.state = {
      isTablet: false,
      isShortDesktop: false,
      isHidden: false,
      isDocked: false,
      isPageActStory: false,
      showPlayButton: true,
      activeIndex: 0,
      activeAlias: '',
      activeAudioFile: '',
      activeTheme: '',
    };
  }

  componentDidMount() {
    // Is tablet?
    this.mqTablet = global.matchMedia('(max-width: 768px)');
    this.mqTabletChange(this.mqTablet);
    this.mqTablet.addListener(this.mqTabletChange.bind(this));
    // Is short desktop?
    this.mqShortDesktop = global.matchMedia(
      '(max-height: 940px) and (min-width: 769px)',
    );
    this.mqShortDesktopChange(this.mqShortDesktop);
    this.mqShortDesktop.addListener(this.mqShortDesktopChange.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    const { location, storyline, entities } = nextProps;
    let pageNotFound = true;

    const state = {
      isHidden: false,
      isDocked: false,
      isPageActStory: false,
      activeIndex: 0,
      activeAlias: '',
      activeAudioFile: '',
      activeTheme: '',
    };

    // Should the wheel be hidden or docked?
    if (location.pathname === '/') {
      // Skip.
    } else if (location.pathname === '/map') {
      state.isHidden = true;
    } else {
      for (let i = 0; i < entities.length; i += 1) {
        if (location.pathname === entities[i].entityUrl.alias) {
          switch (entities[i].entityBundle) {
            case 'act_landing':
            case 'story':
              state.isDocked = true;
              break;
            default:
              state.isHidden = true;
              break;
          }

          // Found the current page. Break out of the for loop.
          pageNotFound = false;
          break;
        }
      }

      if (pageNotFound) {
        state.isHidden = true;
      }
    }

    // Find the current page.
    for (let i = 0; i < storyline.length; i += 1) {
      if (storyline[i].entityUrl.alias === location.pathname) {
        state.isPageActStory = true;
        state.activeIndex = i;
        state.activeAlias = storyline[i].entityUrl.alias;
        state.activeAudioFile = storyline[i].fieldFile;
        state.activeTheme = storyline[i].fieldThemeColor;
        break;
      }
    }

    this.rerunAnimations =
      state.isDocked && state.activeAlias !== this.state.activeAlias;

    this.setState(state);
  }

  componentDidUpdate() {
    if (this.rerunAnimations) {
      global.dispatchEvent(new CustomEvent('runKineticAnimations'));
    }
  }

  componentWillUnmount() {
    if (this.mqTablet) {
      this.mqTablet.removeListener(this.mqTabletChange.bind(this));
    }
  }

  onSwipeMove(delta) {
    this.isVerticalSwipe = Math.abs(delta.y) > Math.abs(delta.x);
  }

  onSwipeLeft() {
    if (this.isVerticalSwipe) {
      return;
    }

    global.dispatchEvent(new CustomEvent('nextStoryline'));
  }

  onSwipeRight() {
    if (this.isVerticalSwipe) {
      return;
    }

    global.dispatchEvent(new CustomEvent('previousStoryline'));
  }

  /* eslint-disable no-nested-ternary */
  getItemStyle(delta) {
    const diameter =
      this.state.isDocked || this.state.isTablet
        ? 650
        : this.state.isShortDesktop ? 500 : 616;
    const angle = 360 / this.props.storyline.length;
    const rot = -90 + angle * (delta - this.state.activeIndex);

    return {
      transform: `rotate(${rot}deg) translate(${diameter / 2}px) rotate(${rot *
        -1}deg)`,
    };
  }
  /* eslint-enable no-nested-ternary */

  playIntro() {
    const promise = global.document
      .querySelectorAll('.site-content__hero video')[0]
      .play();
    if (promise !== undefined) {
      promise.then(this.props.setIntroFinished(false));
    }
  }

  skipIntro() {
    this.props.setIntroFinished(true);
    this.setState({
      showPlayButton: false,
    });
  }

  mqTabletChange(mq) {
    if (this.state.isTablet !== mq.matches) {
      this.setState({
        isTablet: mq.matches,
      });
    }
  }

  mqShortDesktopChange(mq) {
    if (this.state.isShortDesktop !== mq.matches) {
      this.setState({
        isShortDesktop: mq.matches,
      });
    }
  }

  /* eslint-disable react/no-danger, react/jsx-no-bind, react/no-array-index-key */
  render() {
    const { storyline } = this.props;
    const swipeTolerance = 125;
    const hiddenClass = this.state.isHidden ? ' is-hidden' : '';
    const dockedClass = this.state.isDocked
      ? ' site-controls--docked wheel--gradient'
      : ' site-controls--centered';
    const acts = [
      '',
      'I',
      'II',
      'III',
      'IV',
      'V',
      'VI',
      'VII',
      'VIII',
      'IX',
      'X',
      'XI',
      'XII',
      'XIII',
      'XIV',
      'XV',
    ];

    return (
      <Swipe
        onSwipeMove={this.onSwipeMove.bind(this)}
        onSwipeLeft={this.onSwipeLeft.bind(this)}
        onSwipeRight={this.onSwipeRight.bind(this)}
        tolerance={swipeTolerance}
        className={`site-controls wheel--count-${storyline.length} wheel${dockedClass}${hiddenClass}`}
      >
        <div className="wheel__content wheel__info theme--white">
          {this.props.fieldSubtitle
            ? <h2
              className="wheel__subtitle h3 h3--small--tablet theme--aqua"
              dangerouslySetInnerHTML={{ __html: this.props.fieldSubtitle }}
            />
            : ''}
          <span className="wheel__title h4 h4--large">Ferguson Voices</span>
          <Html className="wheel__description h3 h3--small--tablet theme--aqua">
            {this.props.fieldShortDescription}
          </Html>

          <p className="wheel__note hide-on-mobile">
            <span className="wheel__note-text wheel__note-text--right h3 h3--tiny">
              Best Experienced
            </span>
            <span className="btn btn--circle btn--pulsate">
              <span className="svg-wrapper icon center center--both theme--aqua">
                <svg aria-hidden="true" focusable="false">
                  <use xlinkHref="#icon-headphones" />
                </svg>
              </span>
            </span>
            <span className="wheel__note-text h3 h3--tiny">
              with Headphones
            </span>
          </p>

          <div className="wheel__skip-intro theme--aqua">
            {this.state.showPlayButton && !this.props.introPlaying
              ? <span>
                <button
                  onClick={this.playIntro.bind(this)}
                  onMouseDown={event => {
                      // Prevent focus.
                    event.preventDefault();
                  }}
                  className="btn btn--default btn--outline"
                >
                  <span className="btn__child">Play Intro</span>
                </button>
                  &nbsp;&nbsp;&nbsp;
              </span>
              : ''}
            <button
              onClick={this.skipIntro.bind(this)}
              onMouseDown={event => {
                // Prevent focus.
                event.preventDefault();
              }}
              className="btn btn--default btn--outline"
            >
              <span className="btn__child">Skip Intro</span>
            </button>
          </div>
        </div>
        <AudioToggle
          alias={this.state.activeAlias}
          theme={this.state.activeTheme}
          fieldFile={this.state.activeAudioFile}
        />
        <div
          className={`wheel__content wheel__controls wheel__content--align-top theme--${this
            .state.activeTheme}`}
        >
          <div className="wheel__controls controls">
            {this.state.isPageActStory
              ? <ul className="controls__list list js-kinetic-animation">
                <li className="controls__list-item list__item">
                  <Link
                    to={{ hash: '#subscribe-to-podcast' }}
                    className="btn btn--circle"
                    onMouseDown={event => {
                        // Prevent focus.
                      event.preventDefault();
                    }}
                  >
                    <span className="btn__child svg-wrapper icon--tiny center center--both">
                      <svg
                        role="img"
                        aria-labelledby="wheel-controls-rss"
                        focusable="false"
                      >
                        <title id="wheel-controls-rss">
                            Subscribe to the Podcast
                          </title>
                        <use xlinkHref="#icon-rss" />
                      </svg>
                    </span>
                  </Link>
                </li>
                <li className="controls__list-item list__item wheel__more-info">
                  <Link
                    to={{ hash: '#more-info' }}
                    className="btn btn--default btn--small btn--circle btn--radiating"
                    onMouseDown={event => {
                        // Prevent focus.
                      event.preventDefault();
                    }}
                  >
                    <span className="btn__child center center--both">
                        More
                      </span>
                  </Link>
                </li>
                <li className="controls__list-item list__item wheel__close-more-info">
                  <Link
                    to={{ hash: '' }}
                    className="btn btn--default btn--small btn--circle btn--radiating"
                    onMouseDown={event => {
                        // Prevent focus.
                      event.preventDefault();
                    }}
                  >
                    <span className="btn__child svg-wrapper icon--tiny center center--both">
                      <svg
                        role="img"
                        aria-labelledby="wheel-controls-close-more-info"
                        focusable="false"
                      >
                        <title id="wheel-controls-close-more-info">
                            Close More Info
                          </title>
                        <use xlinkHref="#icon-close" />
                      </svg>
                    </span>
                  </Link>
                </li>
                <li className="controls__list-item list__item">
                  <Link
                    to={{ hash: '#share' }}
                    className="btn btn--circle"
                    onMouseDown={event => {
                        // Prevent focus.
                      event.preventDefault();
                    }}
                  >
                    <span className="btn__child svg-wrapper icon--tiny center center--both">
                      <svg
                        role="img"
                        aria-labelledby="wheel-controls-share"
                        focusable="false"
                      >
                        <title id="wheel-controls-share">
                            Share this Page
                          </title>
                        <use xlinkHref="#icon-share" />
                      </svg>
                    </span>
                  </Link>
                </li>
              </ul>
              : ''}
            <Link
              to="/"
              className="btn btn--default btn--outline js-kinetic-animation hide-on-tablet"
            >
              <span className="btn__child">Explore All</span>
            </Link>
          </div>
        </div>

        <nav className="wheel__nav">
          <h2 className="visually-hidden">Storyline Menu</h2>
          {this.state.isPageActStory
            ? ''
            : <div className="wheel__instructions center center--horizontally hide-on-desktop">
              <div className="h3 h3--small--tablet theme--white">
                  Swipe left to explore
                </div>
              <span className="btn btn--no-theme">
                <span className="btn__child svg-wrapper icon--tiny center center--both theme--white">
                  <svg aria-hidden="true" focusable="false">
                    <use xlinkHref="#icon-expand-horizontal" />
                  </svg>
                </span>
              </span>
            </div>}
          {this.props.introFinished || this.state.isPageActStory
            ? <ul className="wheel__nav-list list animate--fade-in-list">
              {storyline.map((menuItem, delta) =>
                  (<li
                    key={`storyline:${delta}`}
                    className={`list__item wheel__nav-item animate--fade-in theme--${menuItem.fieldThemeColor}`}
                    style={this.getItemStyle(delta)}
                  >
                    {menuItem.entityUrl.alias.substring(0, 8) === '/voices/'
                      ? <WheelStoryItem
                        {...menuItem}
                        hide={
                            menuItem.entityUrl.alias === this.state.activeAlias
                          }
                      />
                      : <WheelActItem
                        {...menuItem}
                        act={acts.shift()}
                        hide={
                            menuItem.entityUrl.alias === this.state.activeAlias
                          }
                      />}
                  </li>),
                )}
            </ul>
            : ''}
        </nav>
        <div className="wheel__circle center center--both">
          <svg
            viewBox="0 0 620 620"
            xmlns="http://www.w3.org/2000/svg"
            focusable="false"
          >
            <circle cx="310" cy="310" r="308" className="wheel__circle-path" />
          </svg>
        </div>
      </Swipe>
    );
  }
  /* eslint-enable react/no-danger, react/jsx-no-bind, react/no-array-index-key */
}

const introHasFinished = (bool: Boolean = false) => ({
  type: 'INTRO_FINISHED',
  isPlaying: !bool,
  hasFinished: bool,
});

const mapStateToProps = state => ({
  introPlaying: state.intro.isPlaying,
  introFinished: state.intro.hasFinished,
});

const mapDispatchToProps = dispatch => ({
  setIntroFinished: bool => dispatch(introHasFinished(bool)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Wheel));



// WEBPACK FOOTER //
// ./screens/App/components/Wheel/Wheel.js